// src/components/WhatWeOffer/WhatWeOffer.jsx
import React from "react";
import { Link } from 'react-router-dom';
import "./WhatWeOffer.css";
import { FaLaptopCode, FaMobileAlt, FaCloud, FaCogs, FaShoppingCart, FaDatabase } from "react-icons/fa";

export default function WhatWeOffer() {
  const services = [
    { icon: <FaLaptopCode />, title: "Développement Web", desc: "Création de sites modernes et performants adaptés à vos besoins." },
    { icon: <FaMobileAlt />, title: "Applications Mobiles", desc: "Des apps intuitives pour iOS & Android, pensées pour vos utilisateurs." },
    { icon: <FaCloud />, title: "Solutions Cloud", desc: "Optimisation et hébergement sécurisé sur le cloud." },
    { icon: <FaCogs />, title: "Intégration de systèmes", desc: "Connexion fluide de vos outils et automatisation des processus." },
    { icon: <FaShoppingCart />, title: "Applications e-commerce", desc: "Boutiques en ligne performantes, évolutives et sécurisées pour booster vos ventes." },
    { icon: <FaDatabase />, title: "ERP", desc: "Solutions ERP pour la gestion intégrée et optimisée de votre entreprise." },
  ];

  return (
    <section className="what-we-offer">
      <h2>Ce que nous offrons</h2>
      <p className="intro">
        Nous proposons des solutions digitales innovantes et adaptées : Web, mobile, cloud, CRM et plus encore.
      </p>
      <div className="offer-grid">
        {services.map((service, index) => {
          // robust slug: normalize accents, remove diacritics
          const slug = service.title.toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9\-]/g, '');

          return (
            <Link to={`/services/${slug}`} key={index} className="offer-card-link" aria-label={`Voir plus sur ${service.title}`}>
              <div className="offer-card">
                <div className="icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <div className="see-more">Voir plus →</div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
